import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { Models } from 'models/core';
import { ForeignObjectTypeServiceService } from 'services/foreign-object-type-service-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class ForeignObjectTypeNew {
  private foreignObjectTypeService: Models.ForeignObjectTypeService = new Models.ForeignObjectTypeService();
  protected checkDuplicateData: Models.CheckDuplicateForeignObjectTypeService = new Models.CheckDuplicateForeignObjectTypeService();

  private constructor(
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private foreignObjectTypeServiceService: ForeignObjectTypeServiceService
  ) {}

  @AsyncErrorHandler
  async createForeignObjectTypeService() {
    if (await this.checkDuplicate()) return;

    await this.foreignObjectTypeServiceService.post(this.foreignObjectTypeService);
    this.eventAggregator.publish('foreignObjectTypeListReset', 1);
    this.toastService.showSuccess('service.foreignObjectsCreated');
    this.router.navigateToRoute('foreign-object-type-list');
  }

  @AsyncErrorHandler
  async checkDuplicate() {
    this.checkDuplicateData.ProductId = this.foreignObjectTypeService.ProductId;
    const { IsDuplicate } = await this.foreignObjectTypeServiceService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('foreignObjectTypeIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
